import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "linking-input__linking-container linking-container" }
const _hoisted_2 = { class: "linking-container__tabs" }
const _hoisted_3 = ["value", "onInput"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-label", "onClick"]
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "linking-container__setting"
}
const _hoisted_9 = { class: "linking-container__row-tabs" }
const _hoisted_10 = ["draggable", "onDragstart", "onDragover", "onDragleave", "onDrop"]
const _hoisted_11 = ["value", "onInput"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = ["aria-label", "onClick"]
const _hoisted_15 = ["aria-label", "disabled", "onClick"]
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = {
  key: 0,
  class: "linking-container__rule"
}
const _hoisted_18 = { class: "row-conditions" }
const _hoisted_19 = { class: "row-conditions__header" }
const _hoisted_20 = { class: "row-conditions__title-wrap" }
const _hoisted_21 = { class: "row-conditions__title" }
const _hoisted_22 = { class: "row-conditions__summary" }
const _hoisted_23 = {
  key: 0,
  class: "row-conditions__duplicate-error"
}
const _hoisted_24 = {
  key: 1,
  class: "row-conditions__body"
}
const _hoisted_25 = { class: "row-conditions__join-label" }
const _hoisted_26 = { class: "row-conditions__select-input" }
const _hoisted_27 = {
  key: 1,
  class: "row-conditions__readonly-text"
}
const _hoisted_28 = {
  key: 2,
  class: "row-conditions__error-text"
}
const _hoisted_29 = { class: "row-conditions__select-input" }
const _hoisted_30 = {
  key: 1,
  class: "row-conditions__readonly-text"
}
const _hoisted_31 = {
  key: 2,
  class: "row-conditions__error-text"
}
const _hoisted_32 = { class: "row-conditions__value-cell" }
const _hoisted_33 = {
  key: 0,
  class: "row-conditions__readonly-text"
}
const _hoisted_34 = {
  key: 1,
  class: "row-conditions__readonly-text"
}
const _hoisted_35 = {
  key: 2,
  class: "row-conditions__no-value"
}
const _hoisted_36 = { class: "row-conditions__select-input" }
const _hoisted_37 = ["value", "placeholder", "onChange"]
const _hoisted_38 = ["value", "placeholder", "onChange"]
const _hoisted_39 = {
  key: 4,
  class: "row-conditions__error-text"
}
const _hoisted_40 = { class: "row-conditions__actions" }
const _hoisted_41 = ["aria-label", "onClick"]
const _hoisted_42 = {
  key: 2,
  class: "row-conditions__empty"
}
const _hoisted_43 = { class: "linking-container__left" }
const _hoisted_44 = { class: "linking-container__at--content" }
const _hoisted_45 = { class: "linking-container__at--label label-container" }
const _hoisted_46 = { class: "linking-container__at--label" }
const _hoisted_47 = ["checked", "onChange"]
const _hoisted_48 = { class: "label-container__unused-label" }
const _hoisted_49 = { class: "mapping-compact" }
const _hoisted_50 = { class: "mapping-compact__main" }
const _hoisted_51 = {
  key: 1,
  class: "field--non-editable"
}
const _hoisted_52 = {
  key: 2,
  class: "mapping-compact__summary"
}
const _hoisted_53 = {
  key: 0,
  class: "mapping-compact__summary-separator"
}
const _hoisted_54 = {
  key: 1,
  class: "mapping-compact__summary-part mapping-compact__summary-part--literal"
}
const _hoisted_55 = ["aria-label", "onClick"]
const _hoisted_56 = {
  key: 0,
  class: "mapping-editor"
}
const _hoisted_57 = { class: "mapping-editor__type-row" }
const _hoisted_58 = { class: "mapping-editor__type-label" }
const _hoisted_59 = ["value", "onChange"]
const _hoisted_60 = { value: "column" }
const _hoisted_61 = { value: "literal" }
const _hoisted_62 = { value: "concat" }
const _hoisted_63 = ["value", "type", "placeholder", "onInput"]
const _hoisted_64 = {
  key: 1,
  class: "mapping-editor__parts"
}
const _hoisted_65 = ["value", "onChange"]
const _hoisted_66 = { value: "column" }
const _hoisted_67 = { value: "literal" }
const _hoisted_68 = ["value", "type", "placeholder", "onInput"]
const _hoisted_69 = ["aria-label", "onClick"]
const _hoisted_70 = {
  key: 2,
  class: "mapping-editor__part-error"
}
const _hoisted_71 = { class: "mapping-editor__part-actions" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 1,
  class: "linking-container__at--error"
}
const _hoisted_75 = {
  key: 1,
  class: "linking-container__at--unused"
}
const _hoisted_76 = { class: "linking-container__right" }

import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { AlterableHeaderService } from '@/coreDomainsModule/entities/inputExcelInfo';
import {
  ConditionOperators,
  ConditionValueTypes,
  ImportOrderStatusRule,
  OrderMappingRuleCondition,
  OrderFieldMapping,
  OrderFieldMappings,
  OrderMappingField,
  OrderRowMappingRule,
  RegisterOrderExcelInfo,
  RegisterOrderExcelInfos,
  createId,
  getDataTypeByField,
} from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import type { ConditionOperator, ConditionValueType, OrderFieldMappingDataType } from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { useNativeDragReorder } from '@/corePagesModule/composables/useNativeDragReorder';
import { i18n } from '@/i18n';
import { UNSELECTED_HEADER_VALUE } from '@/registerInputModule/constants';
import { computed, ref, watch } from 'vue';
import { From } from './InputExcelForm.vue';
import InputExcelOrderStatusInfo from './InputExcelOrderStatusInfo.vue';
import SelectableField from '../SelectableField.vue';
import { isRequireAlterableHeader } from '../../interfaces/LinkingInput';
import { RegisterInputViewModel } from '../../RegisterInputViewModel';
import ConditionDateInput from './ConditionDateInput.vue';

type MaybeOrderExcelInfoId = string | undefined;
/** 選択中の行設定。template上では未選択になり得る。 */
type MaybeOrderRowMappingRule = OrderRowMappingRule | undefined;


export default /*@__PURE__*/_defineComponent({
  __name: 'InputOrderExcelForm',
  props: {
    from: {},
    selectedFieldId: {},
    suggestions: {},
    orderExcelInfos: {}
  },
  emits: ["update-selected-field-id", "update-order-excel-infos", "remove-order-excel-info", "confirm-order-excel-info-name"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const vm = new RegisterInputViewModel();
const orderMappingFields = AlterableHeaderService.orderAlterableHeaderList as OrderMappingField[];
const conditionValueTypeLabels: Record<Exclude<ConditionValueType, 'none'>, string> = {
  text: t('文字列'),
  number: t('数値'),
  date: t('日付'),
};
const conditionOperatorLabels: Record<ConditionOperator, string> = Object.fromEntries(
  ConditionOperators.map((operator) => [operator, t(`condition-op-${operator}`)])
) as Record<ConditionOperator, string>;
const conditionOperatorSuggestions = ConditionOperators.map((operator) => conditionOperatorLabels[operator]);
const conditionValueTypeSuggestions = ConditionValueTypes.map((valueType) => conditionValueTypeLabels[valueType]);
const comparableConditionValueTypeSuggestions = ConditionValueTypes.filter((valueType) => valueType !== 'text').map(
  (valueType) => conditionValueTypeLabels[valueType]
);
const containsConditionValueTypeSuggestions = ConditionValueTypes.filter((valueType) => valueType !== 'date').map(
  (valueType) => conditionValueTypeLabels[valueType]
);

const props = __props;

/** 選択中の発注エクセル登録設定ID。template上では未選択になり得る。 */
const emits = __emit;

/**
 * 発注フィールド読み替え設定の初期値を作成する
 */
const createDefaultOrderFieldMappings = (): OrderFieldMappings => {
  return orderMappingFields.reduce<OrderFieldMappings>((fieldMappings, field) => {
    fieldMappings[field] = createColumnOrderFieldMapping(getDataTypeByField(field));
    return fieldMappings;
  }, {} as OrderFieldMappings);
};

/**
 * 列参照マッピングを作成する
 * @param dataType - データタイプ
 * @param column - 列名
 * @param unused - 不使用かどうか
 */
function createColumnOrderFieldMapping(dataType: OrderFieldMappingDataType, column = '', unused = false): OrderFieldMapping {
  return {
    dataType,
    type: 'column',
    column,
    unused,
    validateError: 'none',
  };
}

/**
 * 固定値マッピングを作成する
 * @param dataType - データタイプ
 * @param value - 固定値
 * @param unused - 不使用かどうか
 */
function createLiteralOrderFieldMapping(dataType: OrderFieldMappingDataType, value = '', unused = false): OrderFieldMapping {
  return {
    dataType,
    type: 'literal',
    value,
    unused,
    validateError: 'none',
  };
}

/**
 * 連結マッピングを作成する
 * @param dataType - データタイプ
 * @param parts - 連結する部品
 * @param unused - 不使用かどうか
 */
function createConcatOrderFieldMapping(
  dataType: OrderFieldMappingDataType,
  parts: OrderFieldMapping[] = [createColumnOrderFieldMapping(dataType)],
  unused = false
): OrderFieldMapping {
  return {
    dataType,
    type: 'concat',
    parts: parts.map((part) => normalizeOrderFieldMappingDataType(part, dataType)),
    unused,
    validateError: 'none',
  };
}

/**
 * 発注フィールドマッピングにデータタイプを補完する
 * @param mapping - 発注フィールドマッピング
 * @param dataType - データタイプ
 */
function normalizeOrderFieldMappingDataType(mapping: OrderFieldMapping, dataType: OrderFieldMappingDataType): OrderFieldMapping {
  if (mapping.type !== 'concat') return { ...mapping, dataType };
  return {
    ...mapping,
    dataType,
    parts: mapping.parts.map((part) => normalizeOrderFieldMappingDataType(part, dataType)),
  };
}

/**
 * 発注エクセル行設定の初期値を作成する
 * @param name - 行設定名
 * @param priority - 優先度
 */
const createDefaultOrderRowMappingRule = (name: string, priority: number): OrderRowMappingRule => ({
  id: createId('OMR'),
  name,
  priority,
  duplicatePriority: undefined,
  rowConditions: [],
  fieldMappings: createDefaultOrderFieldMappings(),
  orderStatusRules: [],
  fallbackOrderStatus: OrderStatus.ApprovedAwaitingDeliveryDate,
});

/**
 * 行条件の初期値を作成する
 */
const createDefaultRowCondition = (): OrderMappingRuleCondition => ({
  id: createId('OMRC'),
  header: '',
  operator: 'equals',
  valueType: 'text',
  value: '',
  validateError: {
    header: 'none',
    value: 'none',
  },
});

const selectedOrderExcelInfoId = ref<string>('');
const selectedRowMappingRuleId = ref<string>('');
const editingOrderExcelInfoId = ref<string>('');
const editingRowMappingRuleId = ref<string>('');
const expandedOrderFieldMappingIds = ref<string[]>([]);
const rowMappingRulesForDrag = ref<OrderRowMappingRule[]>([]);

watch(
  () => props.orderExcelInfos,
  (orderExcelInfos) => {
    if (orderExcelInfos.some((orderExcelInfo) => orderExcelInfo.id === selectedOrderExcelInfoId.value)) return;
    selectedOrderExcelInfoId.value = orderExcelInfos[0]?.id ?? '';
  },
  { immediate: true }
);

const selectedOrderExcelInfo = computed(() => {
  return props.orderExcelInfos.find((orderExcelInfo) => orderExcelInfo.id === selectedOrderExcelInfoId.value);
});

const selectedRowMappingRule = computed(() => {
  return rowMappingRulesForDrag.value.find((rule) => rule.id === selectedRowMappingRuleId.value);
});

/**
 * 表示する発注エクセル登録設定を選択する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 */
const selectOrderExcelInfo = (orderExcelInfoId: string): void => {
  selectedOrderExcelInfoId.value = orderExcelInfoId;
};

/**
 * 行設定を優先度順に取得する
 * @param orderExcelInfo - 発注エクセル登録設定
 */
const sortedRowMappingRules = (orderExcelInfo: RegisterOrderExcelInfo): OrderRowMappingRule[] => {
  return [...orderExcelInfo.rowMappingRules].sort((a, b) => a.priority - b.priority);
};

watch(
  selectedOrderExcelInfo,
  (orderExcelInfo) => {
    const sortedRules = orderExcelInfo ? sortedRowMappingRules(orderExcelInfo) : [];
    rowMappingRulesForDrag.value = sortedRules;

    if (sortedRules.some((rule) => rule.id === selectedRowMappingRuleId.value)) return;
    selectedRowMappingRuleId.value = sortedRules[0]?.id ?? '';
  },
  { immediate: true, deep: true }
);

/**
 * 表示する発注エクセル行設定を選択する
 * @param rowMappingRuleId - 発注エクセル行設定ID
 */
const selectRowMappingRule = (rowMappingRuleId: string): void => {
  selectedRowMappingRuleId.value = rowMappingRuleId;
};

/**
 * 発注エクセル登録設定名の編集を開始する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 */
const startEditingOrderExcelInfoName = (orderExcelInfoId: string): void => {
  editingOrderExcelInfoId.value = orderExcelInfoId;
};

/**
 * 発注エクセル登録設定名の編集を終了する
 */
const stopEditingOrderExcelInfoName = (): void => {
  if (editingOrderExcelInfoId.value && props.from === 'HomeInput') {
    emits('confirm-order-excel-info-name');
  }
  editingOrderExcelInfoId.value = '';
};

/**
 * Enterキーで発注エクセル登録設定名の編集を終了する
 * @param event - キーボードイベント
 */
const stopEditingOrderExcelInfoNameByEnter = (event: KeyboardEvent): void => {
  if (event.isComposing || event.keyCode === 229) return;
  stopEditingOrderExcelInfoName();
};

/**
 * 発注エクセル行設定名の編集を開始する
 * @param rowMappingRuleId - 発注エクセル行設定ID
 */
const startEditingRowMappingRuleName = (rowMappingRuleId: string): void => {
  editingRowMappingRuleId.value = rowMappingRuleId;
};

/**
 * 発注エクセル行設定名の編集を終了する
 */
const stopEditingRowMappingRuleName = (): void => {
  editingRowMappingRuleId.value = '';
  if (props.from === 'HomeInput') {
  }
};

/**
 * Enterキーで発注エクセル行設定名の編集を終了する
 * @param event - キーボードイベント
 */
const stopEditingRowMappingRuleNameByEnter = (event: KeyboardEvent): void => {
  if (event.isComposing || event.keyCode === 229) return;
  stopEditingRowMappingRuleName();
};

/**
 * 指定した発注エクセル登録設定を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param update - 更新処理
 */
const updateOrderExcelInfo = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  update: (orderExcelInfo: RegisterOrderExcelInfo) => RegisterOrderExcelInfo
): void => {
  if (!orderExcelInfoId) return;

  emits(
    'update-order-excel-infos',
    props.orderExcelInfos.map((orderExcelInfo) => (orderExcelInfo.id === orderExcelInfoId ? update(orderExcelInfo) : orderExcelInfo))
  );
};

/**
 * 発注エクセル登録設定を削除する
 * @param orderExcelInfo - 削除する発注エクセル登録設定
 */
const removeOrderExcelInfo = (orderExcelInfo: RegisterOrderExcelInfo): void => {
  const removedIndex = props.orderExcelInfos.findIndex((currentOrderExcelInfo) => currentOrderExcelInfo.id === orderExcelInfo.id);
  const orderExcelInfos = props.orderExcelInfos.filter((currentOrderExcelInfo) => currentOrderExcelInfo.id !== orderExcelInfo.id);

  if (editingOrderExcelInfoId.value === orderExcelInfo.id) {
    editingOrderExcelInfoId.value = '';
  }

  if (selectedOrderExcelInfoId.value === orderExcelInfo.id) {
    selectedOrderExcelInfoId.value = orderExcelInfos[removedIndex]?.id ?? orderExcelInfos[removedIndex - 1]?.id ?? '';
  }

  if (props.from === 'HomeInput') {
    emits('remove-order-excel-info', orderExcelInfos);
    return;
  }

  emits('update-order-excel-infos', orderExcelInfos);
};

/**
 * 発注エクセル登録設定名を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param name - 設定名
 */
const updateOrderExcelInfoName = (orderExcelInfoId: MaybeOrderExcelInfoId, name: string): void => {
  updateOrderExcelInfo(orderExcelInfoId, (orderExcelInfo) => ({
    ...orderExcelInfo,
    name,
  }));
};

/**
 * 指定した行設定を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 更新後の行設定
 */
const updateOrderMappingRule = (orderExcelInfoId: MaybeOrderExcelInfoId, rule: MaybeOrderRowMappingRule): void => {
  if (!orderExcelInfoId || !rule) return;

  updateOrderExcelInfo(orderExcelInfoId, (orderExcelInfo) => ({
    ...orderExcelInfo,
    rowMappingRules: orderExcelInfo.rowMappingRules.map((rowMappingRule) => (rowMappingRule.id === rule.id ? rule : rowMappingRule)),
  }));
};

/**
 * 発注エクセル行設定名を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param name - 行設定名
 */
const updateOrderMappingRuleName = (orderExcelInfoId: MaybeOrderExcelInfoId, rule: MaybeOrderRowMappingRule, name: string): void => {
  if (!rule) return;

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    name,
  });
};

/**
 * 発注エクセル行設定を追加する
 * @param orderExcelInfo - 発注エクセル登録設定
 */
const addOrderMappingRule = (orderExcelInfo: RegisterOrderExcelInfo): void => {
  const nextPriority =
    orderExcelInfo.rowMappingRules.length > 0 ? Math.max(...orderExcelInfo.rowMappingRules.map((rule) => rule.priority)) + 1 : 0;
  const newRule = createDefaultOrderRowMappingRule(`${t('行条件')}${orderExcelInfo.rowMappingRules.length + 1}`, nextPriority);
  selectedRowMappingRuleId.value = newRule.id;

  updateOrderExcelInfo(orderExcelInfo.id, (currentOrderExcelInfo) => ({
    ...currentOrderExcelInfo,
    rowMappingRules: [...currentOrderExcelInfo.rowMappingRules, newRule],
  }));
};

/**
 * 発注エクセル行設定を削除する
 * @param orderExcelInfo - 発注エクセル登録設定
 * @param rule - 削除する行設定
 */
const removeOrderMappingRule = (orderExcelInfo: RegisterOrderExcelInfo, rule: OrderRowMappingRule): void => {
  const sortedRules = sortedRowMappingRules(orderExcelInfo);
  const removedIndex = sortedRules.findIndex((rowMappingRule) => rowMappingRule.id === rule.id);
  const rowMappingRules = sortedRules
    .filter((rowMappingRule) => rowMappingRule.id !== rule.id)
    .map((rowMappingRule, index) => ({
      ...rowMappingRule,
      priority: index,
    }));

  if (editingRowMappingRuleId.value === rule.id) {
    editingRowMappingRuleId.value = '';
  }

  if (selectedRowMappingRuleId.value === rule.id) {
    selectedRowMappingRuleId.value = rowMappingRules[removedIndex]?.id ?? rowMappingRules[removedIndex - 1]?.id ?? '';
  }

  updateOrderExcelInfo(orderExcelInfo.id, (currentOrderExcelInfo) => ({
    ...currentOrderExcelInfo,
    rowMappingRules,
  }));
};

/**
 * 発注エクセル行設定のDnDキーを取得する
 * @param rule - 発注エクセル行設定
 */
const getRowMappingRuleKey = (rule: OrderRowMappingRule): string => rule.id;

/**
 * 行設定を並び順に合わせて優先度更新する
 */
const handleRowMappingRulesReorder = (): void => {
  const orderExcelInfo = selectedOrderExcelInfo.value;
  if (!orderExcelInfo) return;

  const rowMappingRules = rowMappingRulesForDrag.value.map((rule, index) => ({
    ...rule,
    priority: index,
  }));
  rowMappingRulesForDrag.value = rowMappingRules;

  updateOrderExcelInfo(orderExcelInfo.id, (currentOrderExcelInfo) => ({
    ...currentOrderExcelInfo,
    rowMappingRules,
  }));
};

const {
  handleDragStart: handleRowMappingRuleDragStart,
  handleDragEnd: handleRowMappingRuleDragEnd,
  handleDragOver: handleRowMappingRuleDragOver,
  handleDragLeave: handleRowMappingRuleDragLeave,
  handleDragOverEnd: handleRowMappingRuleDragOverEnd,
  handleDragLeaveEnd: handleRowMappingRuleDragLeaveEnd,
  handleDrop: handleRowMappingRuleDrop,
  handleDropToEnd: handleRowMappingRuleDropToEnd,
  isDragging: isRowMappingRuleDragging,
  isDropTarget: isRowMappingRuleDropTarget,
  isDragOverEnd: isRowMappingRuleDragOverEnd,
} = useNativeDragReorder({
  items: rowMappingRulesForDrag,
  getKey: getRowMappingRuleKey,
  onReorder: handleRowMappingRulesReorder,
});

/**
 * 発注マッピング式を画面表示用の読み替え値に変換する
 * @param mapping - 発注マッピング式
 */
const orderMappingToValue = (mapping?: OrderFieldMapping): string => {
  if (!mapping) return '';
  switch (mapping.type) {
    case 'column':
      return mapping.column;
    case 'literal':
      return mapping.value;
    case 'concat':
      return mapping.parts.map(orderMappingToValue).join('');
  }
};

/**
 * 発注マッピング式を画面表示用のサマリに変換する
 * @param mapping - 発注マッピング式
 */
const orderMappingToSummary = (mapping?: OrderFieldMapping): string => {
  if (!mapping) return '';
  switch (mapping.type) {
    case 'column':
      return mapping.column;
    case 'literal':
      return mapping.value;
    case 'concat':
      return mapping.parts.map((part) => orderMappingToSummary(part) || t('未設定')).join(' + ');
  }
};

/**
 * 発注フィールド詳細設定の開閉キーを取得する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param ruleId - 行設定ID
 * @param field - 発注フィールド
 */
const getOrderFieldMappingDetailKey = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  ruleId: string | undefined,
  field: OrderMappingField
): string => {
  return `${orderExcelInfoId}::${ruleId}::${field}`;
};

/**
 * 発注フィールド詳細設定が開いているかどうか
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param ruleId - 行設定ID
 * @param field - 発注フィールド
 */
const isOrderFieldMappingDetailOpen = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  ruleId: string | undefined,
  field: OrderMappingField
): boolean => {
  if (!orderExcelInfoId || !ruleId) return false;
  return expandedOrderFieldMappingIds.value.includes(getOrderFieldMappingDetailKey(orderExcelInfoId, ruleId, field));
};

/**
 * 発注フィールド詳細設定の開閉を切り替える
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param ruleId - 行設定ID
 * @param field - 発注フィールド
 */
const toggleOrderFieldMappingDetail = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  ruleId: string | undefined,
  field: OrderMappingField
): void => {
  if (!orderExcelInfoId || !ruleId) return;

  const key = getOrderFieldMappingDetailKey(orderExcelInfoId, ruleId, field);
  expandedOrderFieldMappingIds.value = expandedOrderFieldMappingIds.value.includes(key)
    ? expandedOrderFieldMappingIds.value.filter((expandedKey) => expandedKey !== key)
    : [...expandedOrderFieldMappingIds.value, key];
};

/**
 * 発注フィールドの読み替え設定を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param updateValue - 更新値
 */
const updateOrderFieldMapping = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  updateValue: string
): void => {
  if (!rule) return;

  const column = updateValue !== UNSELECTED_HEADER_VALUE ? updateValue : '';
  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    fieldMappings: {
      ...rule.fieldMappings,
      [field]: {
        dataType,
        type: 'column',
        column,
        unused: rule.fieldMappings[field]?.unused ?? false,
        validateError: 'none',
      },
    },
  });
};

/**
 * 発注フィールドマッピングの種別を取得する
 * @param mapping - 発注フィールドマッピング
 */
const getOrderFieldMappingType = (mapping?: OrderFieldMapping): OrderFieldMapping['type'] => mapping?.type ?? 'column';

/**
 * 発注フィールドマッピングのデータタイプを取得する
 * @param mapping - 発注フィールドマッピング
 * @param field - 発注フィールド
 */
const getOrderFieldMappingDataType = (mapping: OrderFieldMapping | undefined, field: OrderMappingField): OrderFieldMappingDataType => {
  return mapping?.dataType ?? getDataTypeByField(field);
};

/**
 * 固定値マッピング用inputのtypeを取得する
 * @param mapping - 発注フィールドマッピング
 * @param field - 発注フィールド
 */
const getOrderFieldLiteralInputType = (mapping: OrderFieldMapping | undefined, field: OrderMappingField): 'text' | 'number' => {
  return getOrderFieldMappingDataType(mapping, field) === 'number' ? 'number' : 'text';
};

/**
 * inputイベントから文字列値を取得する
 * @param event - 入力イベント
 */
const getInputValue = (event: Event): string => (event.target instanceof HTMLInputElement ? event.target.value : '');

/**
 * selectイベントから文字列値を取得する
 * @param event - 変更イベント
 */
const getSelectValue = (event: Event): string => (event.target instanceof HTMLSelectElement ? event.target.value : '');

/**
 * 発注フィールドマッピングの種別を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param mappingType - マッピング種別
 */
const updateOrderFieldMappingType = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  mappingType: string
): void => {
  if (!rule) return;
  if (mappingType !== 'column' && mappingType !== 'literal' && mappingType !== 'concat') return;

  const currentMapping = rule.fieldMappings[field];
  const dataType = currentMapping?.dataType ?? getDataTypeByField(field);
  const unused = currentMapping?.unused ?? false;
  const nextMapping =
    mappingType === 'column'
      ? createColumnOrderFieldMapping(dataType, currentMapping?.type === 'column' ? currentMapping.column : '', unused)
      : mappingType === 'literal'
      ? createLiteralOrderFieldMapping(dataType, currentMapping?.type === 'literal' ? currentMapping.value : '', unused)
      : createConcatOrderFieldMapping(
          dataType,
          currentMapping?.type === 'concat' ? currentMapping.parts : [currentMapping ?? createColumnOrderFieldMapping(dataType)],
          unused
        );

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    fieldMappings: {
      ...rule.fieldMappings,
      [field]: nextMapping,
    },
  });
};

/**
 * 固定値マッピングを更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param value - 固定値
 */
const updateOrderFieldLiteralMapping = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  value: string
): void => {
  if (!rule) return;

  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);
  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    fieldMappings: {
      ...rule.fieldMappings,
      [field]: createLiteralOrderFieldMapping(dataType, value, rule.fieldMappings[field]?.unused ?? false),
    },
  });
};

/**
 * 連結マッピングの部品を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param parts - 更新後の部品
 */
const updateOrderFieldConcatParts = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  parts: OrderFieldMapping[]
): void => {
  if (!rule) return;

  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);
  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    fieldMappings: {
      ...rule.fieldMappings,
      [field]: createConcatOrderFieldMapping(dataType, parts, rule.fieldMappings[field]?.unused ?? false),
    },
  });
};

/**
 * 連結マッピングを取得する
 * @param mapping - 発注フィールドマッピング
 */
const getConcatOrderFieldMapping = (mapping?: OrderFieldMapping): OrderFieldMapping[] => {
  return mapping?.type === 'concat' ? mapping.parts : [];
};

/**
 * 連結部品の種別を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param partIndex - 部品index
 * @param partType - 連結部品の種別
 */
const updateConcatPartType = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  partIndex: number,
  partType: string
): void => {
  if (!rule) return;

  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);
  if (partType !== 'column' && partType !== 'literal') return;
  const parts = getConcatOrderFieldMapping(rule.fieldMappings[field]).map((part, index) =>
    index === partIndex
      ? partType === 'column'
        ? createColumnOrderFieldMapping(dataType)
        : createLiteralOrderFieldMapping(dataType)
      : part
  );
  updateOrderFieldConcatParts(orderExcelInfoId, rule, field, parts);
};

/**
 * 連結部品の列名を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param partIndex - 部品index
 * @param column - 列名
 */
const updateConcatPartColumn = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  partIndex: number,
  column: string
): void => {
  if (!rule) return;

  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);
  const normalizedColumn = column !== UNSELECTED_HEADER_VALUE ? column : '';
  const parts = getConcatOrderFieldMapping(rule.fieldMappings[field]).map((part, index) =>
    index === partIndex ? createColumnOrderFieldMapping(dataType, normalizedColumn) : part
  );
  updateOrderFieldConcatParts(orderExcelInfoId, rule, field, parts);
};

/**
 * 連結部品の固定値を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param partIndex - 部品index
 * @param value - 固定値
 */
const updateConcatPartLiteral = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  partIndex: number,
  value: string
): void => {
  if (!rule) return;

  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);
  const parts = getConcatOrderFieldMapping(rule.fieldMappings[field]).map((part, index) =>
    index === partIndex ? createLiteralOrderFieldMapping(dataType, value) : part
  );
  updateOrderFieldConcatParts(orderExcelInfoId, rule, field, parts);
};

/**
 * 連結部品を追加する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param partType - 追加する部品種別
 */
const addConcatPart = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  partType: 'column' | 'literal'
): void => {
  if (!rule) return;

  const dataType = rule.fieldMappings[field]?.dataType ?? getDataTypeByField(field);
  updateOrderFieldConcatParts(orderExcelInfoId, rule, field, [
    ...getConcatOrderFieldMapping(rule.fieldMappings[field]),
    partType === 'column' ? createColumnOrderFieldMapping(dataType) : createLiteralOrderFieldMapping(dataType),
  ]);
};

/**
 * 連結部品を削除する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param partIndex - 削除する部品index
 */
const removeConcatPart = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  partIndex: number
): void => {
  if (!rule) return;

  updateOrderFieldConcatParts(
    orderExcelInfoId,
    rule,
    field,
    getConcatOrderFieldMapping(rule.fieldMappings[field]).filter((_, index) => index !== partIndex)
  );
};

/**
 * 発注フィールドの不使用設定を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param field - 発注フィールド
 * @param unused - 不使用かどうか
 */
const updateOrderFieldUnused = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  field: OrderMappingField,
  unused: boolean
): void => {
  if (!rule) return;

  const currentMapping = rule.fieldMappings[field];

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    fieldMappings: {
      ...rule.fieldMappings,
      [field]: currentMapping
        ? {
            ...normalizeOrderFieldMappingDataType(currentMapping, currentMapping.dataType ?? getDataTypeByField(field)),
            unused,
            validateError: 'none',
          }
        : {
            dataType: getDataTypeByField(field),
            type: 'column',
            column: '',
            unused,
            validateError: 'none',
          },
    },
  });
};

/**
 * 発注フィールドマッピングの入力エラーメッセージを取得する
 * @param mapping - 発注フィールドマッピング
 */
const getOrderFieldMappingErrorMessage = (mapping?: OrderFieldMapping): string => {
  if (mapping?.validateError === 'notEmpty') return t('記入必須です');
  return '';
};

/**
 * 大小比較を行う条件かどうかを判定する
 * @param operator - 条件演算子
 */
const isComparableOperator = (operator: ConditionOperator): boolean => ['gt', 'gte', 'lt', 'lte'].includes(operator);

/**
 * 部分一致を行う条件かどうかを判定する
 * @param operator - 条件演算子
 */
const isContainsOperator = (operator: ConditionOperator): boolean => ['contains', 'not_contains'].includes(operator);

/**
 * 値入力が不要な条件かどうかを判定する
 * @param operator - 条件演算子
 */
const isNoValueOperator = (operator: ConditionOperator): boolean => operator === 'is_empty' || operator === 'is_not_empty';

/**
 * 条件演算子の表示値を取得する
 * @param operator - 条件演算子
 */
const getOperatorDisplayValue = (operator: ConditionOperator): string => conditionOperatorLabels[operator];

/**
 * 条件演算子の表示名から内部値を取得する
 * @param displayValue - 表示値
 */
const getOperatorByDisplayValue = (displayValue: string): ConditionOperator => {
  return ConditionOperators.find((operator) => conditionOperatorLabels[operator] === displayValue) ?? 'equals';
};

/**
 * 条件値の入力種別表示値を取得する
 * @param valueType - 条件値の入力種別
 */
const getValueTypeDisplayValue = (valueType: ConditionValueType): string => {
  if (valueType === 'none') return '';
  return conditionValueTypeLabels[valueType];
};

/**
 * 条件値の入力種別表示名から内部値を取得する
 * @param displayValue - 表示値
 */
const getValueTypeByDisplayValue = (displayValue: string): Exclude<ConditionValueType, 'none'> => {
  return ConditionValueTypes.find((valueType) => conditionValueTypeLabels[valueType] === displayValue) ?? 'text';
};

/**
 * 条件演算子に応じた条件値種別候補を取得する
 * @param operator - 条件演算子
 */
const getConditionValueTypeSuggestions = (operator: ConditionOperator): string[] => {
  if (isComparableOperator(operator)) return comparableConditionValueTypeSuggestions;
  if (isContainsOperator(operator)) return containsConditionValueTypeSuggestions;
  return conditionValueTypeSuggestions;
};

/**
 * 行条件の値エラー文言を取得する
 * @param condition - 行条件
 */
const getRowConditionValueErrorMessage = (condition: OrderMappingRuleCondition): string => {
  if (condition.validateError?.value === 'notEmpty') return t('記入必須です');
  return '　';
};

/**
 * 行条件を重複判定用の文字列に変換する
 * @param condition - 行条件
 */
const serializeRowCondition = (condition: OrderMappingRuleCondition): string => {
  const value = condition.value == null ? '' : String(condition.value);
  return [condition.header, condition.operator, condition.valueType, value].join('\u001f');
};

/**
 * 行設定の行条件全体を重複判定用の文字列に変換する
 * @param rule - 行設定
 */
const serializeRowConditions = (rule: OrderRowMappingRule): string => {
  if (rule.rowConditions.length === 0) return '__all_rows__';
  return rule.rowConditions.map(serializeRowCondition).sort().join('\u001e');
};

/**
 * 同じ行設定内に同じ条件行があるかどうかを判定する
 * @param rule - 行設定
 */
const hasDuplicatedRowCondition = (rule: OrderRowMappingRule): boolean => {
  const signatures = new Set<string>();
  return rule.rowConditions.some((condition) => {
    const signature = serializeRowCondition(condition);
    if (signatures.has(signature)) return true;
    signatures.add(signature);
    return false;
  });
};

/**
 * 同じ全体設定内の別行設定と行条件全体が重複しているかどうかを判定する
 * @param orderExcelInfo - 発注エクセル登録設定
 * @param rule - 行設定
 */
const hasDuplicatedRowConditionsRule = (orderExcelInfo: RegisterOrderExcelInfo, rule: OrderRowMappingRule): boolean => {
  const signature = serializeRowConditions(rule);
  return orderExcelInfo.rowMappingRules.some(
    (rowMappingRule) => rowMappingRule.id !== rule.id && serializeRowConditions(rowMappingRule) === signature
  );
};

/**
 * 行条件重複エラー文言を取得する
 * @param orderExcelInfo - 発注エクセル登録設定
 * @param rule - 行設定
 */
const getRowConditionDuplicatedErrorMessage = (
  orderExcelInfo: RegisterOrderExcelInfo | undefined,
  rule: MaybeOrderRowMappingRule
): string => {
  if (!orderExcelInfo || !rule) return '';

  if (hasDuplicatedRowConditionsRule(orderExcelInfo, rule)) return t('他の行設定と行の条件が重複しています');
  if (hasDuplicatedRowCondition(rule)) return t('同じ条件行が重複しています');
  return '';
};

/**
 * 行条件数の表示文言を取得する
 * @param rule - 行設定
 */
const getRowConditionSummary = (rule: MaybeOrderRowMappingRule): string => {
  if (!rule) return '';
  if (rule.rowConditions.length === 0) return t('全ての行に適用');
  return `${t('条件数')}: ${rule.rowConditions.length}`;
};

/**
 * 行条件を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param conditions - 更新後の行条件
 */
const updateRowConditions = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  conditions: OrderMappingRuleCondition[]
): void => {
  if (!rule) return;

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    rowConditions: conditions,
  });
};

/**
 * 行条件を追加する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 */
const addRowCondition = (orderExcelInfoId: MaybeOrderExcelInfoId, rule: MaybeOrderRowMappingRule): void => {
  if (!rule) return;

  updateRowConditions(orderExcelInfoId, rule, [...rule.rowConditions, createDefaultRowCondition()]);
};

/**
 * 行条件を削除する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param conditionIndex - 削除する条件index
 */
const removeRowCondition = (orderExcelInfoId: MaybeOrderExcelInfoId, rule: MaybeOrderRowMappingRule, conditionIndex: number): void => {
  if (!rule) return;

  updateRowConditions(
    orderExcelInfoId,
    rule,
    rule.rowConditions.filter((_, index) => index !== conditionIndex)
  );
};

/**
 * 行条件を部分更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param conditionIndex - 更新する条件index
 * @param patch - 更新内容
 */
const updateRowConditionByIndex = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  conditionIndex: number,
  patch: Partial<OrderMappingRuleCondition>
): void => {
  if (!rule) return;

  const conditions = rule.rowConditions.map((condition, index) =>
    index === conditionIndex
      ? {
          ...condition,
          ...patch,
          validateError: {
            header: patch.header != null ? 'none' : condition.validateError?.header ?? 'none',
            value: patch.value !== undefined ? 'none' : condition.validateError?.value ?? 'none',
          },
        }
      : condition
  );

  updateRowConditions(orderExcelInfoId, rule, conditions);
};

/**
 * 行条件の演算子を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param conditionIndex - 更新する条件index
 * @param displayValue - 条件演算子表示値
 */
const updateRowConditionOperator = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  conditionIndex: number,
  displayValue: string
): void => {
  if (!rule) return;

  const currentCondition = rule.rowConditions[conditionIndex];
  if (!currentCondition) return;
  const operator = getOperatorByDisplayValue(displayValue);

  const condition: OrderMappingRuleCondition = {
    ...currentCondition,
    operator,
    validateError: {
      ...currentCondition.validateError,
      value: 'none',
    },
  };

  if (isNoValueOperator(operator)) {
    condition.valueType = 'none';
    condition.value = null;
  } else if (condition.valueType === 'none') {
    condition.valueType = 'text';
    condition.value = '';
  } else if (isComparableOperator(operator) && condition.valueType === 'text') {
    condition.valueType = 'number';
    condition.value = null;
  } else if (isContainsOperator(operator) && condition.valueType === 'date') {
    condition.valueType = 'text';
    condition.value = String(condition.value ?? '');
  }

  updateRowConditionByIndex(orderExcelInfoId, rule, conditionIndex, condition);
};

/**
 * 行条件の値種別を更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param conditionIndex - 更新する条件index
 * @param displayValue - 値種別表示値
 */
const updateRowConditionValueType = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  conditionIndex: number,
  displayValue: string
): void => {
  if (!rule) return;

  const valueType = getValueTypeByDisplayValue(displayValue);
  updateRowConditionByIndex(orderExcelInfoId, rule, conditionIndex, {
    valueType,
    value: valueType === 'number' ? null : '',
  });
};

/**
 * 発注ステータス変換ルールを取得する
 * @param rule - 行設定
 * @returns 発注ステータス変換ルール
 */
const getImportOrderStatusRules = (rule: MaybeOrderRowMappingRule): ImportOrderStatusRule[] => rule?.orderStatusRules ?? [];

/**
 * 発注ステータス変換ルールを更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param rules - 発注ステータス変換ルール
 */
const updateImportOrderStatusRules = (
  orderExcelInfoId: MaybeOrderExcelInfoId,
  rule: MaybeOrderRowMappingRule,
  rules: ImportOrderStatusRule[]
): void => {
  if (!rule) return;

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    orderStatusRules: rules,
  });
};

/**
 * 条件に一致しない場合の発注ステータスを取得する
 * @param rule - 行設定
 * @returns 条件に一致しない場合の発注ステータス
 */
const getFallbackOrderStatus = (rule: MaybeOrderRowMappingRule): OrderStatus =>
  rule?.fallbackOrderStatus ?? OrderStatus.ApprovedAwaitingDeliveryDate;

/**
 * 条件に一致しない場合の発注ステータスを更新する
 * @param orderExcelInfoId - 発注エクセル登録設定ID
 * @param rule - 行設定
 * @param status - 発注ステータス
 */
const updateFallbackOrderStatus = (orderExcelInfoId: MaybeOrderExcelInfoId, rule: MaybeOrderRowMappingRule, status: OrderStatus): void => {
  if (!rule) return;

  updateOrderMappingRule(orderExcelInfoId, {
    ...rule,
    fallbackOrderStatus: status,
  });
};

const isEditing = computed(() => props.from === 'LinkingInput');

/**
 * 必須フィールドをunusedにした時のテキストのi18nキーを返す
 * @param dataType - データタイプ
 */
const getUnusedTextI18nKey = (dataType?: OrderFieldMappingDataType) => {
  switch (dataType) {
    case 'number':
      return '取引紐付け：文言不使用（数値）';
    case 'date':
      return '取引紐付け：文言不使用（日付）';
    case 'string':
    default:
      return '取引紐付け：文言不使用';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderExcelInfos, (orderExcelInfo) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `order-excel-info-tab-${orderExcelInfo.id}`,
          class: _normalizeClass(["linking-container__tab", {
          'linking-container__tab--editing': isEditing.value,
          'linking-container__tab--deletable': _ctx.from === 'HomeInput',
          'linking-container__tab--active': orderExcelInfo.id === selectedOrderExcelInfoId.value,
        }])
        }, [
          (editingOrderExcelInfoId.value === orderExcelInfo.id)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                value: orderExcelInfo.name,
                type: "text",
                class: "linking-container__tab-input",
                onInput: ($event: any) => (updateOrderExcelInfoName(orderExcelInfo.id, getInputValue($event))),
                onBlur: stopEditingOrderExcelInfoName,
                onKeydown: _withKeys(stopEditingOrderExcelInfoNameByEnter, ["enter"])
              }, null, 40, _hoisted_3))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "linking-container__tab-label",
                onClick: ($event: any) => (selectOrderExcelInfo(orderExcelInfo.id))
              }, _toDisplayString(orderExcelInfo.name), 9, _hoisted_4)),
          (editingOrderExcelInfoId.value === orderExcelInfo.id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "linking-container__tab-icon-button",
                "aria-label": _unref(t)('設定名の編集を完了'),
                onClick: stopEditingOrderExcelInfoName
              }, [
                _createVNode(Mdi, { icon: "check" })
              ], 8, _hoisted_5))
            : (props.from !== 'FinishInput')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  class: "linking-container__tab-icon-button",
                  "aria-label": _unref(t)('設定名を編集'),
                  onClick: ($event: any) => (startEditingOrderExcelInfoName(orderExcelInfo.id))
                }, [
                  _createVNode(Mdi, { icon: "edit" })
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
          (_ctx.from === 'HomeInput')
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                type: "button",
                class: "linking-container__tab-icon-button linking-container__tab-icon-button--danger",
                "aria-label": _unref(t)('全体設定を削除'),
                onClick: ($event: any) => (removeOrderExcelInfo(orderExcelInfo))
              }, [
                _createVNode(Mdi, {
                  icon: "delete",
                  variant: "outlined"
                })
              ], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    (selectedOrderExcelInfo.value != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowMappingRulesForDrag.value, (rule) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `order-rule-tab-${selectedOrderExcelInfo.value?.id}-${rule.id}`,
                class: _normalizeClass(["linking-container__row-tab", {
              'linking-container__row-tab--editing': isEditing.value,
              'linking-container__row-tab--active': rule.id === selectedRowMappingRuleId.value,
              'linking-container__row-tab--dragging': _unref(isRowMappingRuleDragging)(rule),
              'linking-container__row-tab--drop-target': _unref(isRowMappingRuleDropTarget)(rule),
            }]),
                draggable: isEditing.value,
                onDragstart: ($event: any) => (_unref(handleRowMappingRuleDragStart)($event, rule)),
                onDragend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleRowMappingRuleDragEnd) && _unref(handleRowMappingRuleDragEnd)(...args))),
                onDragover: ($event: any) => (_unref(handleRowMappingRuleDragOver)($event, rule)),
                onDragleave: ($event: any) => (_unref(handleRowMappingRuleDragLeave)($event, rule)),
                onDrop: ($event: any) => (_unref(handleRowMappingRuleDrop)($event, rule))
              }, [
                (editingRowMappingRuleId.value === rule.id)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      value: rule.name,
                      type: "text",
                      class: "linking-container__tab-input",
                      draggable: "false",
                      onInput: ($event: any) => (updateOrderMappingRuleName(selectedOrderExcelInfo.value?.id, rule, getInputValue($event))),
                      onBlur: stopEditingRowMappingRuleName,
                      onKeydown: _withKeys(stopEditingRowMappingRuleNameByEnter, ["enter"])
                    }, null, 40, _hoisted_11))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "linking-container__tab-label",
                      onClick: ($event: any) => (selectRowMappingRule(rule.id))
                    }, _toDisplayString(rule.name), 9, _hoisted_12)),
                (editingRowMappingRuleId.value === rule.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "linking-container__tab-icon-button",
                      "aria-label": _unref(t)('行設定名の編集を完了'),
                      onClick: stopEditingRowMappingRuleName
                    }, [
                      _createVNode(Mdi, { icon: "check" })
                    ], 8, _hoisted_13))
                  : (isEditing.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "linking-container__tab-icon-button",
                        "aria-label": _unref(t)('行設定名を編集'),
                        onClick: ($event: any) => (startEditingRowMappingRuleName(rule.id))
                      }, [
                        _createVNode(Mdi, { icon: "edit" })
                      ], 8, _hoisted_14))
                    : _createCommentVNode("", true),
                (isEditing.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      type: "button",
                      class: "linking-container__tab-icon-button linking-container__tab-icon-button--danger",
                      "aria-label": _unref(t)('行設定を削除'),
                      draggable: "false",
                      disabled: selectedOrderExcelInfo.value.rowMappingRules.length <= 1,
                      onClick: ($event: any) => (removeOrderMappingRule(selectedOrderExcelInfo.value, rule))
                    }, [
                      _createVNode(Mdi, {
                        icon: "delete",
                        variant: "outlined"
                      })
                    ], 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_10))
            }), 128)),
            (isEditing.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "linking-container__row-tab-add-button",
                  "aria-label": _unref(t)('行設定を追加'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (addOrderMappingRule(selectedOrderExcelInfo.value)))
                }, [
                  _createVNode(Mdi, { icon: "add" })
                ], 8, _hoisted_16))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["linking-container__row-tab-end-drop", { 'linking-container__row-tab-end-drop--active': _unref(isRowMappingRuleDragOverEnd) }]),
              onDragover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleRowMappingRuleDragOverEnd) && _unref(handleRowMappingRuleDragOverEnd)(...args))),
              onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleRowMappingRuleDragLeaveEnd) && _unref(handleRowMappingRuleDragLeaveEnd)(...args))),
              onDrop: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(handleRowMappingRuleDropToEnd) && _unref(handleRowMappingRuleDropToEnd)(...args)))
            }, null, 34)
          ]),
          (selectedRowMappingRule.value != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h3", _hoisted_21, _toDisplayString(_unref(t)('行の条件設定')), 1),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(getRowConditionSummary(selectedRowMappingRule.value)), 1)
                    ]),
                    (isEditing.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "row-conditions__add-button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (addRowCondition(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value)))
                        }, [
                          _createVNode(Mdi, { icon: "add" }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('条件行を追加')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (getRowConditionDuplicatedErrorMessage(selectedOrderExcelInfo.value, selectedRowMappingRule.value))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(getRowConditionDuplicatedErrorMessage(selectedOrderExcelInfo.value, selectedRowMappingRule.value)), 1))
                    : _createCommentVNode("", true),
                  (selectedRowMappingRule.value.rowConditions.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRowMappingRule.value.rowConditions, (condition, conditionIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: condition.id,
                            class: "row-conditions__row"
                          }, [
                            _createElementVNode("div", _hoisted_25, _toDisplayString(conditionIndex === 0 ? '' : _unref(t)('かつ')), 1),
                            _createElementVNode("div", _hoisted_26, [
                              (isEditing.value)
                                ? (_openBlock(), _createBlock(SelectableField, {
                                    key: 0,
                                    value: condition.header || undefined,
                                    "selected-id": condition.header,
                                    hint: _unref(t)('項目を選択'),
                                    suggestions: _ctx.suggestions,
                                    onUpdateValue: ($event: any) => (
                        updateRowConditionByIndex(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex, { header: $event })
                      )
                                  }, null, 8, ["value", "selected-id", "hint", "suggestions", "onUpdateValue"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(condition.header), 1)),
                              (isEditing.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(condition.validateError?.header === 'notEmpty' ? _unref(t)('記入必須です') : '　'), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              (isEditing.value)
                                ? (_openBlock(), _createBlock(SelectableField, {
                                    key: 0,
                                    value: getOperatorDisplayValue(condition.operator),
                                    "selected-id": `${condition.id}-operator`,
                                    suggestions: _unref(conditionOperatorSuggestions),
                                    onUpdateValue: ($event: any) => (updateRowConditionOperator(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex, $event))
                                  }, null, 8, ["value", "selected-id", "suggestions", "onUpdateValue"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(getOperatorDisplayValue(condition.operator)), 1)),
                              (isEditing.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString('　')))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              (!isEditing.value && isNoValueOperator(condition.operator))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "--"))
                                : (!isEditing.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(condition.value ?? ''), 1))
                                  : (isNoValueOperator(condition.operator))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, "--"))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createVNode(SelectableField, {
                                            value: getValueTypeDisplayValue(condition.valueType),
                                            "selected-id": `${condition.id}-value-type`,
                                            suggestions: getConditionValueTypeSuggestions(condition.operator),
                                            onUpdateValue: ($event: any) => (
                            updateRowConditionValueType(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex, $event)
                          )
                                          }, null, 8, ["value", "selected-id", "suggestions", "onUpdateValue"])
                                        ]),
                                        (condition.valueType === 'number')
                                          ? (_openBlock(), _createElementBlock("input", {
                                              key: 0,
                                              value: condition.value ?? '',
                                              class: "row-conditions__input",
                                              type: "number",
                                              placeholder: _unref(t)('入力してください'),
                                              onChange: ($event: any) => (
                          updateRowConditionByIndex(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex, {
                            value: getInputValue($event) === '' ? null : Number(getInputValue($event)),
                          })
                        )
                                            }, null, 40, _hoisted_37))
                                          : (condition.valueType === 'date')
                                            ? (_openBlock(), _createBlock(ConditionDateInput, {
                                                key: 1,
                                                "model-value": condition.value,
                                                "onUpdate:modelValue": ($event: any) => (
                          updateRowConditionByIndex(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex, { value: $event })
                        )
                                              }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                            : (_openBlock(), _createElementBlock("input", {
                                                key: 2,
                                                value: condition.value ?? '',
                                                class: "row-conditions__input",
                                                type: "text",
                                                placeholder: _unref(t)('入力してください'),
                                                onChange: ($event: any) => (
                          updateRowConditionByIndex(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex, {
                            value: getInputValue($event),
                          })
                        )
                                              }, null, 40, _hoisted_38))
                                      ], 64)),
                              (isEditing.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(getRowConditionValueErrorMessage(condition)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              (isEditing.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "row-conditions__icon-button",
                                    "aria-label": _unref(t)('条件削除'),
                                    onClick: ($event: any) => (removeRowCondition(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, conditionIndex))
                                  }, [
                                    _createVNode(Mdi, { icon: "close" })
                                  ], 8, _hoisted_41))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('条件なしの場合は全ての行に適用されます')), 1)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderMappingFields), (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `order-field-${selectedOrderExcelInfo.value?.id}-${selectedRowMappingRule.value?.id}-${field}`,
                      class: "linking-container__at"
                    }, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(vm).displayHeaderTitle(field)), 1),
                          (_ctx.from !== 'HomeInput' && _unref(isRequireAlterableHeader)(field))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("input", {
                                  checked: selectedRowMappingRule.value.fieldMappings[field]?.unused ?? false,
                                  type: "checkbox",
                                  class: "label-container__checkbox",
                                  onChange: ($event: any) => (
                            updateOrderFieldUnused(
                              selectedOrderExcelInfo.value?.id,
                              selectedRowMappingRule.value,
                              field,
                              ($event.target as HTMLInputElement).checked
                            )
                          )
                                }, null, 40, _hoisted_47),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)('取引紐付け：チェックボックス：不使用')), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        (!(selectedRowMappingRule.value.fieldMappings[field]?.unused ?? false))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                  (isEditing.value && getOrderFieldMappingType(selectedRowMappingRule.value.fieldMappings[field]) === 'column')
                                    ? (_openBlock(), _createBlock(SelectableField, {
                                        key: 0,
                                        value: orderMappingToValue(selectedRowMappingRule.value.fieldMappings[field]),
                                        "selected-id": _ctx.selectedFieldId,
                                        hint: _unref(t)('取引紐付け：サジェストヒント'),
                                        suggestions: _ctx.suggestions,
                                        onUpdateValue: ($event: any) => (updateOrderFieldMapping(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, $event)),
                                        onUpdateSelectedId: _cache[6] || (_cache[6] = ($event: any) => (emits('update-selected-field-id', $event)))
                                      }, null, 8, ["value", "selected-id", "hint", "suggestions", "onUpdateValue"]))
                                    : (getOrderFieldMappingType(selectedRowMappingRule.value.fieldMappings[field]) === 'column')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(orderMappingToSummary(selectedRowMappingRule.value.fieldMappings[field]) ||
                              (_unref(isRequireAlterableHeader)(field) ? '-' : '')), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          (selectedRowMappingRule.value.fieldMappings[field]?.type === 'concat')
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getConcatOrderFieldMapping(selectedRowMappingRule.value.fieldMappings[field]), (part, partIndex) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: `mapping-summary-${selectedOrderExcelInfo.value?.id}-${selectedRowMappingRule.value?.id}-${field}-${partIndex}`
                                                }, [
                                                  (partIndex > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, "+"))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["mapping-compact__summary-part", { 'mapping-compact__summary-part--literal': part.type === 'literal' }])
                                                  }, _toDisplayString(orderMappingToSummary(part) || _unref(t)('未設定')), 3)
                                                ], 64))
                                              }), 128))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(orderMappingToSummary(selectedRowMappingRule.value.fieldMappings[field]) ||
                                (_unref(isRequireAlterableHeader)(field) ? '-' : '')), 1))
                                        ]))
                                ]),
                                (isEditing.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "mapping-compact__detail-button",
                                      "aria-label": _unref(t)('詳細設定'),
                                      onClick: ($event: any) => (toggleOrderFieldMappingDetail(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value?.id, field))
                                    }, [
                                      _createVNode(Mdi, { icon: "more_horiz" })
                                    ], 8, _hoisted_55))
                                  : _createCommentVNode("", true)
                              ]),
                              (isEditing.value && isOrderFieldMappingDetailOpen(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value?.id, field))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(t)('種別')), 1),
                                      _createElementVNode("select", {
                                        value: getOrderFieldMappingType(selectedRowMappingRule.value.fieldMappings[field]),
                                        class: "mapping-editor__type-select",
                                        onChange: ($event: any) => (
                              updateOrderFieldMappingType(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, getSelectValue($event))
                            )
                                      }, [
                                        _createElementVNode("option", _hoisted_60, _toDisplayString(_unref(t)('列')), 1),
                                        _createElementVNode("option", _hoisted_61, _toDisplayString(_unref(t)('固定値')), 1),
                                        _createElementVNode("option", _hoisted_62, _toDisplayString(_unref(t)('連結')), 1)
                                      ], 40, _hoisted_59)
                                    ]),
                                    (getOrderFieldMappingType(selectedRowMappingRule.value.fieldMappings[field]) === 'literal')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (getOrderFieldMappingDataType(selectedRowMappingRule.value.fieldMappings[field], field) === 'date')
                                            ? (_openBlock(), _createBlock(ConditionDateInput, {
                                                key: 0,
                                                "model-value": 
                              selectedRowMappingRule.value.fieldMappings[field]?.type === 'literal'
                                ? selectedRowMappingRule.value.fieldMappings[field]?.value
                                : ''
                            ,
                                                class: "mapping-editor__date-input",
                                                "onUpdate:modelValue": ($event: any) => (
                              updateOrderFieldLiteralMapping(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, $event)
                            )
                                              }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                            : (_openBlock(), _createElementBlock("input", {
                                                key: 1,
                                                value: 
                              selectedRowMappingRule.value.fieldMappings[field]?.type === 'literal'
                                ? selectedRowMappingRule.value.fieldMappings[field]?.value
                                : ''
                            ,
                                                class: "mapping-editor__literal-input",
                                                type: getOrderFieldLiteralInputType(selectedRowMappingRule.value.fieldMappings[field], field),
                                                placeholder: _unref(t)('固定値'),
                                                onInput: ($event: any) => (
                              updateOrderFieldLiteralMapping(
                                selectedOrderExcelInfo.value?.id,
                                selectedRowMappingRule.value,
                                field,
                                getInputValue($event)
                              )
                            )
                                              }, null, 40, _hoisted_63))
                                        ], 64))
                                      : (getOrderFieldMappingType(selectedRowMappingRule.value.fieldMappings[field]) === 'concat')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConcatOrderFieldMapping(selectedRowMappingRule.value.fieldMappings[field]), (part, partIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: `mapping-part-${selectedOrderExcelInfo.value?.id}-${selectedRowMappingRule.value?.id}-${field}-${partIndex}`,
                                                class: "mapping-editor__part"
                                              }, [
                                                _createElementVNode("select", {
                                                  value: part.type === 'literal' ? 'literal' : 'column',
                                                  class: "mapping-editor__part-type",
                                                  onChange: ($event: any) => (
                                updateConcatPartType(
                                  selectedOrderExcelInfo.value?.id,
                                  selectedRowMappingRule.value,
                                  field,
                                  partIndex,
                                  getSelectValue($event)
                                )
                              )
                                                }, [
                                                  _createElementVNode("option", _hoisted_66, _toDisplayString(_unref(t)('列')), 1),
                                                  _createElementVNode("option", _hoisted_67, _toDisplayString(_unref(t)('固定値')), 1)
                                                ], 40, _hoisted_65),
                                                (part.type === 'column')
                                                  ? (_openBlock(), _createBlock(SelectableField, {
                                                      key: 0,
                                                      value: part.column,
                                                      "selected-id": _ctx.selectedFieldId,
                                                      hint: _unref(t)('取引紐付け：サジェストヒント'),
                                                      suggestions: _ctx.suggestions,
                                                      onUpdateValue: ($event: any) => (
                                updateConcatPartColumn(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, partIndex, $event)
                              ),
                                                      onUpdateSelectedId: _cache[7] || (_cache[7] = ($event: any) => (emits('update-selected-field-id', $event)))
                                                    }, null, 8, ["value", "selected-id", "hint", "suggestions", "onUpdateValue"]))
                                                  : (part.type === 'literal')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        (getOrderFieldMappingDataType(part, field) === 'date')
                                                          ? (_openBlock(), _createBlock(ConditionDateInput, {
                                                              key: 0,
                                                              "model-value": part.value,
                                                              class: "mapping-editor__date-input",
                                                              "onUpdate:modelValue": ($event: any) => (
                                  updateConcatPartLiteral(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, partIndex, $event)
                                )
                                                            }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                                          : (_openBlock(), _createElementBlock("input", {
                                                              key: 1,
                                                              value: part.value,
                                                              class: "mapping-editor__literal-input",
                                                              type: getOrderFieldLiteralInputType(part, field),
                                                              placeholder: _unref(t)('固定値'),
                                                              onInput: ($event: any) => (
                                  updateConcatPartLiteral(
                                    selectedOrderExcelInfo.value?.id,
                                    selectedRowMappingRule.value,
                                    field,
                                    partIndex,
                                    getInputValue($event)
                                  )
                                )
                                                            }, null, 40, _hoisted_68))
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "mapping-editor__icon-button",
                                                  "aria-label": _unref(t)('削除'),
                                                  onClick: ($event: any) => (removeConcatPart(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, partIndex))
                                                }, [
                                                  _createVNode(Mdi, { icon: "close" })
                                                ], 8, _hoisted_69),
                                                (getOrderFieldMappingErrorMessage(part))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(getOrderFieldMappingErrorMessage(part)), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("div", _hoisted_71, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "mapping-editor__add-button",
                                                onClick: ($event: any) => (addConcatPart(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, 'column'))
                                              }, [
                                                _createVNode(Mdi, { icon: "add" }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)('列')), 1)
                                              ], 8, _hoisted_72),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "mapping-editor__add-button",
                                                onClick: ($event: any) => (addConcatPart(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, field, 'literal'))
                                              }, [
                                                _createVNode(Mdi, { icon: "add" }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)('固定値')), 1)
                                              ], 8, _hoisted_73)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (getOrderFieldMappingErrorMessage(selectedRowMappingRule.value.fieldMappings[field]))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(getOrderFieldMappingErrorMessage(selectedRowMappingRule.value.fieldMappings[field])), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_unref(t)(getUnusedTextI18nKey(selectedRowMappingRule.value.fieldMappings[field]?.dataType))), 1))
                      ])
                    ]))
                  }), 128))
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "linking-container__separator" }, null, -1)),
                _createElementVNode("div", _hoisted_76, [
                  _createVNode(InputExcelOrderStatusInfo, {
                    rules: getImportOrderStatusRules(selectedRowMappingRule.value),
                    "fallback-status": getFallbackOrderStatus(selectedRowMappingRule.value),
                    suggestions: props.suggestions,
                    "is-editing": props.from === 'LinkingInput',
                    "onUpdate:rules": _cache[8] || (_cache[8] = ($event: any) => (updateImportOrderStatusRules(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, $event))),
                    "onUpdate:fallbackStatus": _cache[9] || (_cache[9] = ($event: any) => (updateFallbackOrderStatus(selectedOrderExcelInfo.value?.id, selectedRowMappingRule.value, $event)))
                  }, null, 8, ["rules", "fallback-status", "suggestions", "is-editing"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})